import {Image} from "@pg-design/image-module";
import {useUserDevice} from "@pg-mono/user-device";

import {gtmHeroBanerClick} from "../../tracking/google_tag_manager/gtm_hero_banner";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {TdaDesktopWrap} from "../components/TdaDesktopWrap";
import {TdaMobileWrap} from "../components/TdaMobileWrap";
import {tdaMobileImageHolder} from "../styles/tda_mobile_image_holder";
import {ITdaCreation} from "../types/ITdaCreation";

interface IProps {
    creation: ITdaCreation;
    url: string;
    preventGtmOnMobile?: boolean;
}

export function TdaCreation(props: IProps) {
    const {creation, preventGtmOnMobile, url} = props;

    const {isMobile} = useUserDevice();

    const onRedirectToUrlClick = () => {
        if (!preventGtmOnMobile || !isMobile) {
            gtmHeroBanerClick();
        }

        window.open(url, "_blank");
    };

    if (isMobile) {
        return (
            <TdaMobileWrap>
                <Image
                    onClick={onRedirectToUrlClick}
                    css={tdaMobileImageHolder}
                    imageStyle={{objectFit: "fill", height: "100%"}}
                    alt={creation.name}
                    width="375px"
                    height="484px"
                    ratio={{xs: "375/484"}}
                    src={getThumbnailLink(creation.mobile_image_url, 375, 484) ?? creation.mobile_image?.m_img_375x484}
                    src2x={getThumbnailLink(creation.mobile_image_url, 750, 968) ?? creation.mobile_image?.m_img_750x968}
                    src3x={getThumbnailLink(creation.mobile_image_url, 1125, 1452) ?? creation.mobile_image?.m_img_1125x1452}
                />
            </TdaMobileWrap>
        );
    }

    return (
        <TdaDesktopWrap backgroundColor={creation.background_color}>
            <Image
                onClick={onRedirectToUrlClick}
                alt={creation.name}
                width="1100px"
                height="220px"
                src={getThumbnailLink(creation.desktop_image_url, 1100, 220) ?? creation.desktop_image.d_img_1100x220}
                src2x={getThumbnailLink(creation.desktop_image_url, 2200, 440) ?? creation.desktop_image.d_img_2200x440}
                src3x={getThumbnailLink(creation.desktop_image_url, 3300, 660) ?? creation.desktop_image.d_img_3300x660}
            />
        </TdaDesktopWrap>
    );
}
import {Image} from "@pg-design/image-module";
import {useUserDevice} from "@pg-mono/user-device";

import {gtmHeroBanerClick} from "../../tracking/google_tag_manager/gtm_hero_banner";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {TdaDesktopWrap} from "../components/TdaDesktopWrap";
import {TdaMobileWrap} from "../components/TdaMobileWrap";
import {tdaMobileImageHolder} from "../styles/tda_mobile_image_holder";
import {ITdaCreation} from "../types/ITdaCreation";

interface IProps {
    creation: ITdaCreation;
    url: string;
    preventGtmOnMobile?: boolean;
}

export function TdaCreation(props: IProps) {
    const {creation, preventGtmOnMobile, url} = props;

    const {isMobile} = useUserDevice();

    const onRedirectToUrlClick = () => {
        if (!preventGtmOnMobile || !isMobile) {
            gtmHeroBanerClick();
        }

        window.open(url, "_blank");
    };

    if (isMobile) {
        return (
            <TdaMobileWrap>
                <Image
                    onClick={onRedirectToUrlClick}
                    css={tdaMobileImageHolder}
                    imageStyle={{objectFit: "fill", height: "100%"}}
                    alt={creation.name}
                    width="375px"
                    height="484px"
                    ratio={{xs: "375/484"}}
                    src={getThumbnailLink(creation.mobile_image_url, 375, 484) ?? creation.mobile_image?.m_img_375x484}
                    src2x={getThumbnailLink(creation.mobile_image_url, 750, 968) ?? creation.mobile_image?.m_img_750x968}
                    src3x={getThumbnailLink(creation.mobile_image_url, 1125, 1452) ?? creation.mobile_image?.m_img_1125x1452}
                />
            </TdaMobileWrap>
        );
    }

    return (
        <TdaDesktopWrap backgroundColor={creation.background_color}>
            <Image
                onClick={onRedirectToUrlClick}
                alt={creation.name}
                width="1100px"
                height="220px"
                src={getThumbnailLink(creation.desktop_image_url, 1100, 220) ?? creation.desktop_image.d_img_1100x220}
                src2x={getThumbnailLink(creation.desktop_image_url, 2200, 440) ?? creation.desktop_image.d_img_2200x440}
                src3x={getThumbnailLink(creation.desktop_image_url, 3300, 660) ?? creation.desktop_image.d_img_3300x660}
            />
        </TdaDesktopWrap>
    );
}
